
import { useParams, useNavigate } from 'react-router-dom';
import { RSVPFlow } from './components/RSVPFlow';

const RSVPPage = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();

  if (!eventId) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p>Invalid event ID</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <RSVPFlow eventId={eventId} />
    </div>
  );
};

export default RSVPPage;
